var _path, _text, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSamplePlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 21,
    viewBox: "0 0 70 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7C0.5 6.17157 1.17157 5.5 2 5.5H69.5V19C69.5 19.8284 68.8284 20.5 68 20.5H2C1.17157 20.5 0.5 19.8284 0.5 19V7Z",
    fill: "#e7369e",
    stroke: "#e7369e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 15,
    fontSize: 8,
    fontFamily: "Arial, sans-serif",
    fill: "white",
    textAnchor: "middle"
  }, "\n    Sample Plan\n  ")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 0.5L70 5H66V0.5Z",
    fill: "#e7369e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamplePlan);
export default __webpack_public_path__ + "static/media/Sample Plan.e3edfe94fc5a6b112f3cd390578ce734.svg";
export { ForwardRef as ReactComponent };